<style scoped>
.placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.placeholder-inner {
  text-align: center;
}
.placeholder-text {
  font-size: 20px;
  color: #585b80;
}
</style>

<template>
  <div class="placeholder">
    <div class="placeholder-inner">
      <img src="../../assets/monitor.svg" width="250px" height="160px"><br>
      <span class="placeholder-text">{{ text }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Placeholder',
  props: {
    text: {
      type: String,
      default: ''
    }
  }
}
</script>
